// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__iiGcS","ranges":"BmiRanges_ranges__3KwRz"};